<div class="promotions-page">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="overview-hero">
    <div class="hero-copy">
      <span class="hero-kicker">Marketing</span>

      <h1>Promotion <span>Management</span></h1>

      <p>
        Manage discount codes, linked services, usage limits, campaign dates,
        and promotion activity from one workspace.
      </p>

      <div class="salon-scope-pill">
        <span>Salon view</span>
        <strong>{{ salonContext.selectionLabel() }}</strong>
      </div>
    </div>

    <div class="hero-actions">
      <button
        type="button"
        class="overview-btn overview-btn--dark"
        (click)="addDiscount()"
      >
        Add Discount
      </button>
    </div>
  </section>

  <section class="kpi-grid">
    <article class="kpi-card kpi-card--primary">
      <div>
        <span>Total Promotions</span>
        <strong>{{ promoVouchers.length || 0 }}</strong>
        <p>Promotion codes available across the selected salon view.</p>
      </div>
    </article>

    <article class="kpi-card">
      <div>
        <span>Active</span>
        <strong>{{ activePromoCount }}</strong>
        <p>Promotions currently active across the selected salons.</p>
      </div>
    </article>

    <article class="kpi-card">
      <div>
        <span>Inactive</span>
        <strong>{{ inactivePromoCount }}</strong>
        <p>Promotions paused or disabled in the selected salon view.</p>
      </div>
    </article>

    <article class="kpi-card">
      <div>
        <span>Average Discount</span>
        <strong>{{ averageDiscountLabel }}</strong>
        <p>Average discount value across the selected promotions.</p>
      </div>
    </article>
  </section>

  <section class="panel">
    <header class="panel-head">
      <div>
        <span class="panel-kicker">Promo Directory</span>

        <h2>Promotion List</h2>

        <p>
          Review active promos, discount values, dates, and linked services
          within the selected salon view.
        </p>
      </div>

      <div class="panel-actions">
        <glo-control
          icon="search"
          placeholder="Search promotions"
          classes="bg-gray-50"
          (valueChange)="onSearch($event)"
        >
        </glo-control>
      </div>
    </header>

    @if (filteredPromoVouchers.length > 0) {
      <div class="table-shell">
        <table>
          <thead>
            <tr>
              <th>Promotion</th>
              <th>Salon</th>
              <th>Code</th>
              <th>Type</th>
              <th>Value</th>
              <th>Dates</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            @for (
              voucher of viewPromoVouchers;
              track trackByVoucherID($index, voucher)
            ) {
              <tr>
                <td>
                  <div class="promo-cell">
                    <div class="promo-avatar">
                      {{ getPromoInitial(voucher) }}
                    </div>

                    <div>
                      <strong>
                        {{ voucher.name || "Untitled Promotion" }}
                      </strong>

                      <span>
                        {{ voucher.service_name || "Service promotion" }}
                      </span>
                    </div>
                  </div>
                </td>

                <td>
                  <span class="salon-pill">
                    {{ getPromotionSalonName(voucher) }}
                  </span>
                </td>

                <td>
                  <span class="code-pill">
                    {{ voucher.code || "NO CODE" }}
                  </span>
                </td>

                <td>
                  <span class="type-pill">
                    {{ formatDiscountType(voucher.discount_type) }}
                  </span>
                </td>

                <td>
                  <strong class="value-text">
                    {{ formatDiscountValue(voucher) }}
                  </strong>
                </td>

                <td>
                  <div class="date-cell">
                    <strong>
                      {{ formatDate(voucher.start_date) || "No start" }}
                    </strong>

                    <span>
                      to {{ formatDate(voucher.end_date) || "No end" }}
                    </span>
                  </div>
                </td>

                <td>
                  <span
                    class="status-pill"
                    [class.status-pill--active]="voucher.is_active"
                    [class.status-pill--inactive]="!voucher.is_active"
                  >
                    {{ voucher.is_active ? "Active" : "Inactive" }}
                  </span>
                </td>

                <td>
                  <div class="row-actions">
                    <button type="button" (click)="editDiscount(voucher)">
                      Edit
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <glo-pagination
        *ngIf="filteredPromoVouchers.length > 0"
        [totalItems]="filteredPromoVouchers.length"
        [currentPage]="currentPage"
        [itemsPerPage]="itemsPerPage"
        [itemsPerPageOptions]="[10, 20, 50, 100]"
        (currentPageChange)="onPageChange($event)"
        (itemsPerPageChange)="onItemsPerPageChange($event)"
      >
      </glo-pagination>
    } @else if (!isLoading) {
      <div class="empty-state">
        <div class="empty-icon">P</div>

        <strong>No promotions found</strong>

        <p>
          There are no promotions available for the currently selected salon
          view. Select another salon or create a new discount code.
        </p>

        <button
          type="button"
          class="overview-btn overview-btn--dark"
          (click)="addDiscount()"
        >
          Add Discount
        </button>
      </div>
    }
  </section>

  <div class="mobile-action">
    <button
      type="button"
      class="overview-btn overview-btn--dark"
      (click)="addDiscount()"
    >
      Add Discount
    </button>
  </div>
</div>
